import React, { useState, useEffect, useContext } from 'react';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { OrderDetailContext } from '../OrderDetailContext';
import Button from '@material-ui/core/Button';

// SERVICES
import { getBetterViewiFrame, logout } from '../../../services';
import Loading from '../../Loading';

const styles = theme => ({});

const getImage = filename => require(`../../../assets/images/${filename}`);
const BV_LOGO = getImage('bv-logo.png');

export const OrderDetailBetterViewiFrameTab = withStyles(styles)(({ orderLineId, classes }) => {
  const { state, dispatch } = useContext(OrderDetailContext);

  // const [modalVisible, setModalVisible] = useState(false);
  // const [actionMode, setActionMode] = useState(null);
  const [repotrCodes, setReportCodes] = useState([]);
  const [iFrame, setiFrameLink] = useState(null);
  const [loadingIFrame, setLoadingIFrame] = useState(true);

  useEffect(() => {
    const getBetterViewiFrameAsync = async () => {
      try {
        setLoadingIFrame(true);
        const link = await getBetterViewiFrame(orderLineId);
        setiFrameLink(link);
      } catch (error) {
        console.log('BetterView iFrame error', error);
      } finally {
        setLoadingIFrame(false);
      }
    };

    getBetterViewiFrameAsync();
  }, []);

  if (loadingIFrame)
    return (
      <div className={cn('flex-1', 'col-center-center')}>
        <Loading />
      </div>
    );

  return (
    <div className={cn('flex-1', 'col-center-center')}>
      {!!iFrame ? (
        <React.Fragment>
          <iframe src={iFrame} width="100%" height="100%" title="Betterview"></iframe>
          {/* <span>
            <a href={iFrame} target="_blank">
              <img src={BV_LOGO} />
            </a>
          </span>
          <span>Click the Betterview logo to access your order</span> */}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <img src={BV_LOGO} />
          <span>This order has no BetterView Data</span>

          <Button style={{ marginBottom: 10, marginTop: 20 }} variant="contained" className={cn(classes.actionButton)}>
            Create Order
          </Button>
        </React.Fragment>
      )}

      {/* <iframe src={iFrame}></iframe> */}
    </div>
  );
});

OrderDetailBetterViewiFrameTab.propTypes = {};

OrderDetailBetterViewiFrameTab.defaultProps = {};
